var _defs, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.64,51.84a4.34,4.34,0,0,1-2-.48,4.29,4.29,0,0,1-2.33-3.83V12.47A4.3,4.3,0,0,1,20.13,9L44.85,26.49A4.31,4.31,0,0,1,46.66,30a4.23,4.23,0,0,1-1.81,3.5L20.13,51A4.29,4.29,0,0,1,17.64,51.84Zm0-41.68a2.32,2.32,0,0,0-2.31,2.31V47.53A2.3,2.3,0,0,0,19,49.41L43.69,31.88h0a2.31,2.31,0,0,0,0-3.76L19,10.59A2.24,2.24,0,0,0,17.65,10.16Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 60,
    height: 60
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.9d04ff9a2666f31ce512810ecb9a8368.svg";
export { ForwardRef as ReactComponent };